module.exports = __webpack_public_path__ + "img/icons_26.15e50c01.svg";